import { PercentageValue } from "../percentage_value";
import { ShortlistWithScores } from "../types";

type AvailabilityCellProps = {
  shortlist: ShortlistWithScores;
};

export const AvailabilityCell = ({ shortlist }: AvailabilityCellProps) => (
  <PercentageValue value={shortlist.scores?.availabilityScore ?? null} />
);
